<template>
  <div class="referenceCheck">
    <el-form :model="basicInfoObj" label-width="120px">
      <title-bar title="公司信息" />
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="公司名称：">
            <el-input v-model="basicInfoObj.corporateName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="应聘职位：">
            <el-input v-model="basicInfoObj.recruitmentPosition" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="项目顾问：">
            <el-input v-model="basicInfoObj.projectConsultant" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人才供应商：">
            <el-input v-model="basicInfoObj.talentSupplier" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="日期：">
            <el-input v-model="basicInfoObj.dateTime" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <title-bar title="公文认证" />
      <el-image class="head-portrait" :src="referenceCheckObj.headPortraits" fit="fit" />
      <el-form-item label="姓名：">
        <el-input class="middle-input" v-model="referenceCheckObj.name" placeholder="请输入" />
      </el-form-item>
      <title-bar title="目前薪资" />
      <el-form-item
        v-if="referenceCheckObj.isYears !== 0 && referenceCheckObj.isYears !== 1"
        :label="referenceCheckObj.isYears ? '年薪：' : '月薪：'"
      >
        <el-input
          class="mini-input"
          v-model="referenceCheckObj.currentSalaryStart"
          placeholder="请输入"
        />&nbsp;~
        <el-input
          class="mini-input"
          v-model="referenceCheckObj.currentSalaryEnd"
          placeholder="请输入"
        />
      </el-form-item>
      <title-bar title="教育背景" />
      <div class="common-style">
        <el-table :data="personEducational" border>
          <el-table-column prop="date" label="时间" width="200">
            <template v-slot="{ row }">
              <div>{{ row.startDate }}~{{ row.endDate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="schoolName" label="学校" width="180" />
          <el-table-column prop="education" label="学历" />
          <el-table-column prop="major" label="专业" />
        </el-table>
      </div>
      <title-bar title="工作经历及内容" />
      <div v-for="(item, index) in personExperience" :key="index">
        <content-bar
          :startTime="item.inductionTime"
          :endTime="item.quitTime"
          :contentName="item.companyName"
          :position="item.position"
          contentTitle="职位内容"
          :content="item.operatingDuty"
        />
      </div>
    </el-form>
    <el-form label-width="120px">
      <title-bar title="履历核实" />
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="受访对象：">
            <el-input v-model="referenceCheckObj.lnterviewees" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="受访对象公司：">
            <el-input v-model="referenceCheckObj.targetCompany" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="受访对象岗位：">
            <el-input v-model="referenceCheckObj.intervieweePosition" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="受访对象时间：">
            <data-time
              @dateChange="interviewClick"
              :parentYear="referenceCheckObj.intervieweeYears"
              :parentMonth="referenceCheckObj.intervieweeMonths"
              :parentDay="referenceCheckObj.intervieweeDay"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="雇主名称：">
            <el-input v-model="referenceCheckObj.employerName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="岗位名称：">
            <el-input v-model="referenceCheckObj.postName" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="工作关系：">
        <el-tag
          :key="index"
          v-for="(item, index) in referenceCheckObj.workingRelationshipss"
          :closable="index > 4"
          :disable-transitions="false"
          :class="{ isActive: referenceCheckObj.workingRelationship === item }"
          @close="handleClose(item)"
          @click="tagClick((referenceCheckObj.workingRelationship = item))"
        >
          {{ item }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">
          + 自定义
        </el-button>
      </el-form-item>
      <el-form-item label="工作时间：">
        <div class="work-time">
          <data-time
            @dateChange="startTimeClick"
            :parentYear="referenceCheckObj.workingHoursYears"
            :parentMonth="referenceCheckObj.workingHoursMonths"
            :isShowDay="false"
          />~&nbsp;
          <data-time
            @dateChange="endTimeClick"
            :parentYear="referenceCheckObj.endWorkingTimeYears"
            :parentMonth="referenceCheckObj.endWorkingTimeMonths"
            :isShowDay="false"
          />
        </div>
      </el-form-item>
      <el-form-item label="工作职责：">
        <el-input
          v-model="referenceCheckObj.operatingDuty"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="工作表现：">
        <el-input
          v-model="referenceCheckObj.workPerformance"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="工作态度：">
        <el-input
          v-model="referenceCheckObj.workingAttitude"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="性格：">
        <el-input
          v-model="referenceCheckObj.characters"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="职业操守：">
        <el-input
          v-model="referenceCheckObj.professionalEthics"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="人际关系：">
        <el-input
          v-model="referenceCheckObj.interpersonalRelationship"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="有待提升：">
        <el-input
          v-model="referenceCheckObj.improved"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="离职原因：">
        <el-input
          v-model="referenceCheckObj.reasonsResignation"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="当时薪资：">
        <el-input v-model="referenceCheckObj.corporateName" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="劳动争议：">
        <el-radio-group v-model="referenceCheckObj.laborDispute">
          <el-radio v-for="(item, index) in extraInfo" :key="index" :label="item.value">
            {{ item.value }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="违禁行为：">
        <el-radio-group v-model="referenceCheckObj.prohibited">
          <el-radio v-for="(item, index) in extraInfo" :key="index" :label="item.value">
            {{ item.value }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="竞业禁止协议：">
        <el-radio-group v-model="referenceCheckObj.competeAgreement">
          <el-radio v-for="(item, index) in extraInfo" :key="index" :label="item.value">
            {{ item.value }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <title-bar title="附录" />
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="身份证正面">
            <upload-image :imageUrls.sync="referenceCheckObj.frontIdCard" />
            <el-button
              v-if="referenceCheckObj.frontIdCard"
              @click="deleteImg('身份证正面')"
              style="margin-top: 10px"
            >
              删除图片
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证反面">
            <upload-image :imageUrls.sync="referenceCheckObj.reverseIdCard" />
            <el-button
              v-if="referenceCheckObj.reverseIdCard"
              @click="deleteImg('身份证反面')"
              style="margin-top: 10px"
            >
              删除图片
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="院校毕业证">
            <upload-image :imageUrls.sync="referenceCheckObj.collegeGraduation" />
            <el-button
              v-if="referenceCheckObj.collegeGraduation"
              @click="deleteImg('院校毕业证')"
              style="margin-top: 10px"
            >
              删除图片
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="院校学院证">
            <upload-image :imageUrls.sync="referenceCheckObj.collegeCertificate" />
            <el-button
              v-if="referenceCheckObj.collegeCertificate"
              @click="deleteImg('院校学院证')"
              style="margin-top: 10px"
            >
              删除图片
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="control-btn">
        <el-button type="primary" @click="saveReferenceCheck">保存</el-button>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary">下载</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import DataTime from '@/components/DataTime.vue'
import contentBar from './cpns/contentBar.vue'
import UploadImage from '@/components/UploadImage.vue'
import { getReferenceCheck, addReferenceCheck } from '@/api/projectCenter'

export default {
  name: 'ReferenceCheck',

  props: {
    currentTab: {
      type: String
    },
    personCode: {
      type: String,
      required: true
    },
    projectId: {
      type: Number
    },
    talentInfo: {
      type: Object
    },
    companyInfo: {
      type: Object
    }
  },

  components: {
    TitleBar,
    contentBar,
    DataTime,
    UploadImage
  },

  data() {
    return {
      basicInfoObj: {
        corporateName: '', // 公司名称
        talentSupplier: '菁锐人才', // 人才供应商
        recruitmentPosition: '', // 应聘职位
        projectConsultant: '', // 项目顾问
        dateTime: this.$df(new Date().getTime(), 'yyyy-mm-dd') // 日期
      },
      referenceCheckObj: {
        headPortraits: '', // 头像
        name: '', // 姓名
        lnterviewees: '', // 受访对象
        targetCompany: '', // 受访对象公司
        intervieweePosition: '', // 受访对象岗位
        intervieweeYears: null, // 受访对象时间的年
        intervieweeMonths: null, // 受访对象时间的月
        intervieweeDay: null, // 受访对象时间的日
        employerName: '', // 雇主名称
        postName: '', // 岗位名称
        isYears: null, // 目前月薪/年薪
        currentSalaryStart: '', // 目前开始薪资
        currentSalaryEnd: '', // 目前结束薪资
        workingRelationship: '', // 工作关系
        workingHoursYears: null, // 工作时间的年份
        workingHoursMonths: null, // 工作时间的月份
        endWorkingTimeYears: null, // 结束工作时间的年份
        endWorkingTimeMonths: null, // 结束工作时间的月份
        operatingDuty: '', // 工作职责
        workPerformance: '', // 工作表现
        workingAttitude: '', // 工作态度
        characters: '', // 性格
        professionalEthics: '', // 职业操守
        interpersonalRelationship: '', // 人际关系
        improved: '', // 有待提升
        reasonsResignation: '', // 离职原因
        laborDispute: '', // 劳动争议
        prohibited: '', // 违禁行为
        competeAgreement: '', // 竞业禁止协议
        frontIdCard: '', // 身份证正面
        reverseIdCard: '', // 身份证反面
        collegeGraduation: '', // 院校毕业证
        collegeCertificate: '', // 院校学院证
        annualSalary: '', // 0为月薪 1为年薪
        monthlySalary: '', // 开始薪资
        annualBonus: '', // 结束薪资
        workingRelationshipss: ['上司', '同事', '下属', '客户', '供应商'] // 工作关系
      },
      personEducational: [], // 教育背景
      personExperience: [], // 工作经历
      extraInfo: [{ value: '有' }, { value: '无' }, { value: '不确定' }],
      id: '',
      inputVisible: false, // el-tag的input框
      inputValue: '' // 输入框的值
    }
  },

  watch: {
    currentTab: {
      handler: function (newVal) {
        if (newVal === 'second') {
          this.search()
        }
      },
      immediate: true
    },
    talentInfo: {
      handler(newVal) {
        Object.keys(newVal).forEach((item) => {
          if (this.referenceCheckObj.hasOwnProperty(item)) {
            this.referenceCheckObj[item] = newVal[item]
          }
        })
        this.personEducational = newVal.personEducational
        this.personExperience = newVal.personExperience
      },
      immediate: true
    },
    companyInfo: {
      handler(newVal) {
        Object.keys(newVal).forEach((item) => {
          if (this.basicInfoObj.hasOwnProperty(item)) {
            this.basicInfoObj[item] = newVal[item]
          }
        })
      },
      immediate: true
    }
  },

  methods: {
    async search() {
      const { data: res } = await getReferenceCheck({ id: this.personCode })
      if (res.resultCode === 200) {
        if (res.data) {
          this.id = res.data.id

          Object.keys(res.data).forEach((item) => {
            if (this.referenceCheckObj.hasOwnProperty(item)) {
              this.referenceCheckObj[item] = res.data[item]
            }
          })
          if (!res.data.workingRelationshipss) {
            this.referenceCheckObj.workingRelationshipss = [
              '上司',
              '同事',
              '下属',
              '客户',
              '供应商'
            ]
          }

          this.referenceCheckObj.intervieweeYears = this.stringToNumber(res.data.intervieweeYears)

          this.referenceCheckObj.intervieweeMonths = this.stringToNumber(res.data.intervieweeMonths)

          this.referenceCheckObj.intervieweeDay = this.stringToNumber(res.data.intervieweeDay)

          this.referenceCheckObj.workingHoursYears = this.stringToNumber(res.data.workingHoursYears)

          this.referenceCheckObj.workingHoursMonths = this.stringToNumber(
            res.data.workingHoursMonths
          )

          this.referenceCheckObj.endWorkingTimeYears = this.stringToNumber(
            res.data.endWorkingTimeYears
          )

          this.referenceCheckObj.endWorkingTimeMonths = this.stringToNumber(
            res.data.endWorkingTimeMonths
          )
        }
      }
    },
    // 将字符串转化为数组
    stringToNumber(val) {
      if (val) {
        return Number(val)
      } else {
        return null
      }
    },
    async saveReferenceCheck() {
      const { data: res } = await addReferenceCheck({
        personnelId: this.personCode,
        projectId: this.projectId,
        id: this.id,
        ...this.referenceCheckObj
      })
      if (res.resultCode === 200) {
        this.$message.success('操作成功')
        this.search()
      }
    },
    interviewClick(year, month, day) {
      this.referenceCheckObj.intervieweeYears = year
      this.referenceCheckObj.intervieweeMonths = month
      this.referenceCheckObj.intervieweeDay = day
    },
    startTimeClick(year, month) {
      this.referenceCheckObj.workingHoursYears = year
      this.referenceCheckObj.workingHoursMonths = month
    },
    endTimeClick(year, month) {
      this.referenceCheckObj.endWorkingTimeYears = year
      this.referenceCheckObj.endWorkingTimeMonths = month
    },
    deleteImg(name) {
      switch (name) {
        case '身份证正面':
          this.referenceCheckObj.frontIdCard = ''
          break

        case '身份证反面':
          this.referenceCheckObj.reverseIdCard = ''
          break

        case '院校毕业证':
          this.referenceCheckObj.collegeGraduation = ''
          break

        case '院校学院证':
          this.referenceCheckObj.collegeCertificate = ''
          break
      }
    },
    handleClose(tag) {
      this.referenceCheckObj.workingRelationshipss.splice(
        this.referenceCheckObj.workingRelationshipss.indexOf(tag),
        1
      )
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.referenceCheckObj.workingRelationshipss.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.referenceCheck {
  background: #fff;
  padding: 20px 10px;
  .common-style {
    margin: 0 30px 20px;
  }
  .head-portrait {
    width: 100px;
    height: 100px;
    margin: 0 0 20px 40px;
  }
  .work-time {
    display: flex;
  }
  .control-btn {
    text-align: center;
  }
  .el-tag {
    cursor: pointer;
  }
  .isActive {
    background: #17757a;
    color: #fff;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 34px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
}
</style>
